module.exports = __webpack_public_path__ + "static/media/wanmask.125a4a90.png";